import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-help-google-ads-details',
  templateUrl: './help-google-ads-details.component.html'
})
export class HelpGoogleAdsDetailsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
